export const API_REQUEST_SOURCE_STORAGE_KEY = 'apiRequestSource';
export const API_REQUEST_SOURCE_VALUE = 'AI Web';

/**
 * Writes the API request source to session storage to flag a visit as originating
 * from a Cresta chat interaction. Session storage is automatically cleared when
 * the browser tab closes, satisfying the requirement that attribution must NOT
 * carry over to a subsequent return session.
 *
 * This avoids cookie domain/path complexity and leverages session storage's
 * automatic lifecycle management.
 */
export function writeApiRequestSourceStorage(): void {
	if (typeof sessionStorage === 'undefined') return;
	try {
		sessionStorage.setItem(API_REQUEST_SOURCE_STORAGE_KEY, API_REQUEST_SOURCE_VALUE);
	} catch (error) {
		console.error('[Cresta] Failed to write session storage:', error);
	}
}

/**
 * Reads the API request source from session storage.
 */
export function readApiRequestSourceStorage(): string | null {
	if (typeof sessionStorage === 'undefined') return null;
	try {
		return sessionStorage.getItem(API_REQUEST_SOURCE_STORAGE_KEY);
	} catch (error) {
		console.error('[Cresta] Failed to read session storage:', error);
		return null;
	}
}

/**
 * Clears the API request source from session storage.
 */
export function clearApiRequestSourceStorage(): void {
	if (typeof sessionStorage === 'undefined') return;
	try {
		sessionStorage.removeItem(API_REQUEST_SOURCE_STORAGE_KEY);
	} catch (error) {
		console.error('[Cresta] Failed to clear session storage:', error);
	}
}
